import { doc, deleteDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";

type Params = {
  brandId: string;
  settingId: string;
  moduleId: string;
};

export const deleteSettingModule = async (params: Params): Promise<void> => {
  const moduleRef = doc(
    db,
    `brands/${params.brandId}/settings/${params.settingId}/modules/${params.moduleId}`,
  );

  await deleteDoc(moduleRef);
};
